module.exports = __webpack_public_path__ + "img/exit_night.fd0c9d98.svg";